window.essencaReviews = [
  {
    "product": "pod",
    "rating": 5,
    "text": "It is very easy to do. I will definitely buy again and I recommend to family and friends.",
    "date": "2026-09-09",
    "id": "review-001"
  },
  {
    "product": "pod",
    "rating": 5,
    "text": "These are amazing they all smell so nice the extra pods come in handy when changing scents. Super fast delivery thank you and price is right",
    "date": "2026-09-09",
    "id": "review-002"
  },
  {
    "product": "one",
    "rating": 5,
    "text": "Best diffuser I’ve had. And simple",
    "date": "2026-09-07",
    "id": "review-003"
  },
  {
    "product": "one",
    "rating": 1,
    "text": "They sent me the wrong scents!",
    "date": "2026-09-06",
    "id": "review-004"
  },
  {
    "product": "one",
    "rating": 3,
    "text": "",
    "date": "2026-09-04",
    "id": "review-005"
  },
  {
    "product": "one",
    "rating": 5,
    "text": "Yes its easy to use.",
    "date": "2026-09-02",
    "id": "review-006"
  },
  {
    "product": "one",
    "rating": 5,
    "text": "This is so easy to use you don’t need water so it’s waterless. You just pop in your oil and turn it on. It has different settings. I suggest this product I will not go back to those plug-ins. They didn’t last long at all but this baby here it’s doing the job. There’s three boys in the house and as we all know, they are a little stinky at times so I bought one of these for each room.",
    "date": "2026-09-01",
    "id": "review-007"
  },
  {
    "product": "one",
    "rating": 5,
    "text": "Perfect size for travel or a small room. I love that I can change the scent easily, it’s as simple as changing the bottle.",
    "date": "2026-08-30",
    "id": "review-008"
  },
  {
    "product": "one",
    "rating": 5,
    "text": "This waterless diffuser was even better than expected. Lots of fragrance comes out of that little diffuser and pretty much makes my whole main level smell good. It’s so much easier to use than a water diffuser and it’s small enough that you can bring it to whatever room you want. Charging it also makes it so much easier.",
    "date": "2026-08-27",
    "id": "review-009"
  },
  {
    "product": "one",
    "rating": 5,
    "text": "Absolutely freaking amazing!!! A+++ I have bought now more For family members this is so great!",
    "date": "2026-08-26",
    "id": "review-010"
  },
  {
    "product": "pod",
    "rating": 5,
    "text": "These are nice to have I guess, but I thought it was the whole diffuser not the replacement part so for people buying this make sure you’re buying the whole diffuser not just the replacement part",
    "date": "2026-08-25",
    "id": "review-011"
  },
  {
    "product": "one",
    "rating": 5,
    "text": "Me encanta es riquísimo y dura cantidad, siempre compro el floral es mi favorito ❤️",
    "date": "2026-08-24",
    "id": "review-012"
  },
  {
    "product": "one",
    "rating": 3,
    "text": "The humidifier is easy to use. The smell is nice but it’s not very strong. I can barely smell it sometimes.",
    "date": "2026-08-24",
    "id": "review-013"
  },
  {
    "product": "pod",
    "rating": 5,
    "text": "This product came fast, but pay attention people. It is just a replacement pod. I will be ordering the whole piece. I just got a little confused.",
    "date": "2026-08-24",
    "id": "review-014"
  },
  {
    "product": "one",
    "rating": 4,
    "text": "Funciona bien el aroma es genial",
    "date": "2026-08-19",
    "id": "review-015"
  },
  {
    "product": "one",
    "rating": 5,
    "text": "",
    "date": "2026-08-19",
    "id": "review-016"
  },
  {
    "product": "one",
    "rating": 5,
    "text": "Love love. Great product. This is my second order. Easy to use. Great size. Awesome fragrances",
    "date": "2026-08-19",
    "id": "review-017"
  },
  {
    "product": "one",
    "rating": 5,
    "text": "Nice to look at and nice scents! I have 2 already!",
    "date": "2026-08-18",
    "id": "review-018"
  },
  {
    "product": "one",
    "rating": 5,
    "text": "I really like how nice looking it is and it has ambient lighting.You get 4 scent strength levels. Super easy to swap bottles, just push up from the bottom. It works great!",
    "date": "2026-08-17",
    "id": "review-019"
  },
  {
    "product": "one",
    "rating": 1,
    "text": "Doesn’t put enough scent out and I’m using in a small area",
    "date": "2026-08-15",
    "id": "review-020"
  },
  {
    "product": "one",
    "rating": 1,
    "text": "I personally have to give a good review or the brand said they will make sure I don’t get any future samples sooo look at my. Videos for context don’t recommend",
    "date": "2026-08-13",
    "id": "review-021"
  },
  {
    "product": "one",
    "rating": 5,
    "text": "This little diffuser is small but mighty- packs a big punch with the smell. It’s cute, rechargeable, and can be moved anywhere. Get you one!",
    "date": "2026-08-13",
    "id": "review-022"
  },
  {
    "product": "one",
    "rating": 5,
    "text": "As advertised. Easy to use. Love the fragrances. Nice size. Able to place anywhere",
    "date": "2026-08-13",
    "id": "review-023"
  },
  {
    "product": "one",
    "rating": 4,
    "text": "So easy to use so easy to get it connected. Love, this smells. I ended up getting bakery essence. Now. My house smells like sugar, cookies, snickerdoodles, and vanilla cake.🥰🥰",
    "date": "2026-08-12",
    "id": "review-024"
  },
  {
    "product": "one",
    "rating": 5,
    "text": "",
    "date": "2026-08-12",
    "id": "review-025"
  },
  {
    "product": "one",
    "rating": 5,
    "text": "I really like this product! It has my home smelling amazing.",
    "date": "2026-08-12",
    "id": "review-026"
  },
  {
    "product": "one",
    "rating": 5,
    "text": "Love it!! Great fresh scent options and strong scent! You won’t be disappointed!",
    "date": "2026-08-10",
    "id": "review-027"
  },
  {
    "product": "one",
    "rating": 5,
    "text": "Love this diffuser! Smells so good! Don’t need to worry about cleaning it! And is waterless so it doesn’t mold!!",
    "date": "2026-08-10",
    "id": "review-028"
  },
  {
    "product": "one",
    "rating": 5,
    "text": "Perfect diffuser. Just as described. Very easy to use. I love that I can set the timer or not set it at all. And the strength of scent is up to you!!",
    "date": "2026-08-10",
    "id": "review-029"
  },
  {
    "product": "one",
    "rating": 5,
    "text": "",
    "date": "2026-08-10",
    "id": "review-030"
  },
  {
    "product": "one",
    "rating": 5,
    "text": "Great product! Oils smell great and I love that I can choose the intensit. Will definitely go back to get more oils.",
    "date": "2026-08-08",
    "id": "review-031"
  },
  {
    "product": "one",
    "rating": 5,
    "text": "Okay literally SO CUTE and it didn’t even realize it was cordless. And why was the packaging such good material?? We love that.",
    "date": "2026-08-08",
    "id": "review-032"
  },
  {
    "product": "one",
    "rating": 5,
    "text": "Thank you for my package. It smells really good. I will be buying again for you guys.",
    "date": "2026-08-07",
    "id": "review-033"
  },
  {
    "product": "one",
    "rating": 5,
    "text": "I love this diffuser. It is perfect for my work desk and makes my space smell amazing ! Easy to use!!",
    "date": "2026-08-07",
    "id": "review-034"
  },
  {
    "product": "one",
    "rating": 5,
    "text": "It is easy to set up and use. The sents are great .",
    "date": "2026-08-06",
    "id": "review-035"
  },
  {
    "product": "one",
    "rating": 5,
    "text": "Looks great, cannot wait to try this.great price sale and super fast shipping. Thank you",
    "date": "2026-08-05",
    "id": "review-036"
  },
  {
    "product": "one",
    "rating": 5,
    "text": "It is amazing! It made my room smell soo much better! It also has a really long battery life so I can keep it running all day!",
    "date": "2026-08-05",
    "id": "review-037"
  },
  {
    "product": "one",
    "rating": 5,
    "text": "This works perfectly. So easy to use. Can definitely smell the scent. I love that it is cordless so that I can take it anywhere in my home. Now I need to get the set of three pods for easy scent swap out.",
    "date": "2026-08-05",
    "id": "review-038"
  },
  {
    "product": "one",
    "rating": 5,
    "text": "This diffuser comes in handy for any space in your living area. It smells amazing and distributes evenly throughout your home",
    "date": "2026-08-03",
    "id": "review-039"
  },
  {
    "product": "one",
    "rating": 5,
    "text": "Yes",
    "date": "2026-08-03",
    "id": "review-040"
  },
  {
    "product": "one",
    "rating": 3,
    "text": "",
    "date": "2026-08-02",
    "id": "review-041"
  },
  {
    "product": "one",
    "rating": 5,
    "text": "Love everything about this. The whole smells from this. And no water needed.",
    "date": "2026-08-02",
    "id": "review-042"
  },
  {
    "product": "one",
    "rating": 5,
    "text": "",
    "date": "2026-07-30",
    "id": "review-043"
  },
  {
    "product": "one",
    "rating": 5,
    "text": "Love this. It looks great is perfect size and the best feature is it has settings allowing you to set how long you will have it on and low to high to release more based on your room size. Two people have walked in the house and immediately said it smells amazing. For the price it’s a great gift I plan to buy a few for Christmas gifts.",
    "date": "2026-07-30",
    "id": "review-044"
  },
  {
    "product": "one",
    "rating": 5,
    "text": "This is my second purchase of this item. It’s great for bathrooms! I love the bakery scents. I might order a few more!",
    "date": "2026-07-29",
    "id": "review-045"
  },
  {
    "product": "one",
    "rating": 5,
    "text": "",
    "date": "2026-07-29",
    "id": "review-046"
  },
  {
    "product": "one",
    "rating": 5,
    "text": "",
    "date": "2026-07-28",
    "id": "review-047"
  },
  {
    "product": "one",
    "rating": 3,
    "text": "It keeps cutting off like 4 mins after Everytime I cut it on",
    "date": "2026-07-28",
    "id": "review-048"
  },
  {
    "product": "pod",
    "rating": 5,
    "text": "I love it I will most definitely be ordering again",
    "date": "2026-07-28",
    "id": "review-049"
  },
  {
    "product": "one",
    "rating": 5,
    "text": "",
    "date": "2026-07-27",
    "id": "review-050"
  },
  {
    "product": "one",
    "rating": 5,
    "text": "",
    "date": "2026-07-27",
    "id": "review-051"
  },
  {
    "product": "one",
    "rating": 3,
    "text": "Just started using today. I’ve had it on high for 4 hours and honestly can’t smell anything at all unless I’m standing right over it. I’ll keep working at it.",
    "date": "2026-07-26",
    "id": "review-052"
  },
  {
    "product": "one",
    "rating": 4,
    "text": "Easy to set up and use. Love",
    "date": "2026-07-23",
    "id": "review-053"
  },
  {
    "product": "one",
    "rating": 5,
    "text": "I ordered 3 and plan to order more my house smells so good! The bakery fragrance set is so good!",
    "date": "2026-07-21",
    "id": "review-054"
  },
  {
    "product": "one",
    "rating": 5,
    "text": "Yes I really like this diffuser however I wish it had a power button that allows it to stay on 24 hours a day and not just four hours at Max",
    "date": "2026-07-20",
    "id": "review-055"
  },
  {
    "product": "one",
    "rating": 5,
    "text": "It is very easy to set up and with a click turns on.",
    "date": "2026-07-19",
    "id": "review-056"
  },
  {
    "product": "one",
    "rating": 5,
    "text": "I love that it is waterless and has different timer settings. Very easy to use.",
    "date": "2026-07-19",
    "id": "review-057"
  },
  {
    "product": "one",
    "rating": 5,
    "text": "",
    "date": "2026-07-18",
    "id": "review-058"
  },
  {
    "product": "one",
    "rating": 4,
    "text": "",
    "date": "2026-07-15",
    "id": "review-059"
  },
  {
    "product": "one",
    "rating": 5,
    "text": "I really like it. This is very good for my salon and I’m going to use it. I am very very loving it",
    "date": "2026-07-14",
    "id": "review-060"
  },
  {
    "product": "one",
    "rating": 5,
    "text": "Love this little diffuser！！！ I really really love my Essenca ONE. Like honestly, I didn’t expect to like it this much but it kinda changed my whole routine at home. I’ve used a few other waterless diffusers before and most of them were either too bulky, leaked oil, or just stopped working after a few months. This one is way prettier, smaller, and the scent is actually stronger than I thought it would be. It makes my room smell so good without being messy or over complicated. My favorite part is that the oil doesn’t spill out. With other diffusers I was always worried about knocking them over or getting oil everywhere, but this one feels much cleaner and easier to use. Also the replaceable ScentPod is such a smart idea. If something gets old or clogged, I don’t have to throw away the whole machine, I can just change the pod. That makes me feel like this will last way longer than the other ones I’ve bought. I bought two pods, so I use one scent during the day and then switch to another one at night. It’s sooo convenient. The scents smell really nice too, honestly as good as some of the bigger brands I’ve tried. I’m probably gonna buy a few more for my friends because this would make such a cute gift. Overall I’m super happy with this purchase and would def recommend it.",
    "date": "2026-07-14",
    "id": "review-061"
  },
  {
    "product": "one",
    "rating": 5,
    "text": "genuinely smells like a bakery in my room! i love all the options in scents",
    "date": "2026-07-12",
    "id": "review-062"
  },
  {
    "product": "one",
    "rating": 5,
    "text": "Honestly, I have never had a diffuser smell so good!!! The scents are amazing. And I love the fact you no longer have to deal with filling it up with water. If you want a simple way to make your house smell amazing you need to get your hands on one of these ! ☺️",
    "date": "2026-07-09",
    "id": "review-063"
  },
  {
    "product": "one",
    "rating": 5,
    "text": "I love the fact that it is cordless and waterless! Battery life has been amazing as well. Love that my house always smells good",
    "date": "2026-07-08",
    "id": "review-064"
  },
  {
    "product": "one",
    "rating": 5,
    "text": "So far so good. It works great, and I love not needing water.",
    "date": "2026-07-07",
    "id": "review-065"
  },
  {
    "product": "one",
    "rating": 5,
    "text": "Very easy to use and works very well. I love it.",
    "date": "2026-07-06",
    "id": "review-066"
  },
  {
    "product": "one",
    "rating": 4,
    "text": "It seems to be good quality. The way it distributes the smell in the air is nice. I appreciate the strength setting and the timer. I was surprised that the bottle leaked into the dispenser. I didn’t leave it for long but I imagine it could become an issue if left for too long.",
    "date": "2026-07-04",
    "id": "review-067"
  },
  {
    "product": "one",
    "rating": 5,
    "text": "I absolutely love these. I ordered one for each room in my house 🥰",
    "date": "2026-06-30",
    "id": "review-068"
  },
  {
    "product": "one",
    "rating": 5,
    "text": "Super easy to use and smells amazing 🥰",
    "date": "2026-06-30",
    "id": "review-069"
  },
  {
    "product": "one",
    "rating": 1,
    "text": "It doesn’t work very well and the sense are horrible",
    "date": "2026-06-28",
    "id": "review-070"
  },
  {
    "product": "one",
    "rating": 5,
    "text": "Works great. My friends and family love the way my house smells with this diffuser. It's also easy to operate.",
    "date": "2026-06-24",
    "id": "review-071"
  },
  {
    "product": "one",
    "rating": 5,
    "text": "I absolutely love this diffuser. I had never had once so I tried it out and next time I want to order a larger one. It is so simple to use. I also will be needing more oils so we'll be re-ordering And I hope I will be able to get the same ones as they smell delicious. Thank you, TikT",
    "date": "2026-06-22",
    "id": "review-072"
  },
  {
    "product": "one",
    "rating": 4,
    "text": "",
    "date": "2026-06-21",
    "id": "review-073"
  },
  {
    "product": "one",
    "rating": 4,
    "text": "So far so good! Everything arrived safely and packaged well. It was beyond easy to follow the directions. My only complaint is the way that the directions are printed. Reading words printed on a small loop was/is annoying.",
    "date": "2026-06-19",
    "id": "review-074"
  },
  {
    "product": "one",
    "rating": 5,
    "text": "Love this so much! Smells amazing and love it requires no water!",
    "date": "2026-06-15",
    "id": "review-075"
  },
  {
    "product": "one",
    "rating": 1,
    "text": "Charged diffuser to full capacity following directions. Timer for 2 hours after 35 minutes it stopped. Checked timers and needed to recharge diffuser again.",
    "date": "2026-06-14",
    "id": "review-076"
  },
  {
    "product": "one",
    "rating": 5,
    "text": "It works amazing so far!!",
    "date": "2026-06-08",
    "id": "review-077"
  },
  {
    "product": "one",
    "rating": 5,
    "text": "I love this item , it's amazing and the scent last a very long time, and it a plus you can out it aware I. Ur house to make any space smell amazing",
    "date": "2026-06-08",
    "id": "review-078"
  },
  {
    "product": "pod",
    "rating": 5,
    "text": "It’s incredibly easy to swap between different fragrances. Best of all, there’s no cross-contamination of scents anymore. Total game-changer. Obsessed with these scent pods! Switching fragrances is a breeze, and I never have to deal with mixed scents now. Perfect!",
    "date": "2026-06-08",
    "id": "review-079"
  },
  {
    "product": "one",
    "rating": 4,
    "text": "Very effective and battery lasts long. Scents are really nice. It's very easy to use.",
    "date": "2026-06-07",
    "id": "review-080"
  },
  {
    "product": "one",
    "rating": 4,
    "text": "Very easy to use and works really well. Battery lasts long.",
    "date": "2026-06-07",
    "id": "review-081"
  },
  {
    "product": "one",
    "rating": 1,
    "text": "This product does not disperse the product. I have attempted to troubleshoot via the instructions but still not scent is being released.",
    "date": "2026-06-05",
    "id": "review-082"
  },
  {
    "product": "one",
    "rating": 4,
    "text": "Love it",
    "date": "2026-06-03",
    "id": "review-083"
  },
  {
    "product": "one",
    "rating": 5,
    "text": "",
    "date": "2026-06-03",
    "id": "review-084"
  },
  {
    "product": "one",
    "rating": 5,
    "text": "",
    "date": "2026-05-29",
    "id": "review-085"
  },
  {
    "product": "one",
    "rating": 4,
    "text": "Love the product and the scents. Only dislike is that it doesn’t auto turn on after desired time selected.",
    "date": "2026-05-20",
    "id": "review-086"
  },
  {
    "product": "one",
    "rating": 4,
    "text": "",
    "date": "2026-05-18",
    "id": "review-087"
  },
  {
    "product": "one",
    "rating": 5,
    "text": "",
    "date": "2026-05-12",
    "id": "review-088"
  },
  {
    "product": "one",
    "rating": 5,
    "text": "",
    "date": "2026-05-09",
    "id": "review-089"
  },
  {
    "product": "one",
    "rating": 5,
    "text": "",
    "date": "2026-05-07",
    "id": "review-090"
  },
  {
    "product": "one",
    "rating": 3,
    "text": "I give it three stars because one has to put it to get the heat.",
    "date": "2026-05-07",
    "id": "review-091"
  },
  {
    "product": "one",
    "rating": 5,
    "text": "Good",
    "date": "2026-05-01",
    "id": "review-092"
  },
  {
    "product": "one",
    "rating": 3,
    "text": "....",
    "date": "2026-04-30",
    "id": "review-093"
  },
  {
    "product": "one",
    "rating": 5,
    "text": "Works great, I ordered 2 gonna order one.",
    "date": "2026-04-30",
    "id": "review-094"
  },
  {
    "product": "one",
    "rating": 5,
    "text": "Ordered one, liked it so much i ordered another one. I definitely recommend, I'm gonna order my third. 🌟🌟🌟🌟🌟",
    "date": "2026-04-30",
    "id": "review-095"
  },
  {
    "product": "one",
    "rating": 2,
    "text": "I loved it but it didn’t come with a bottle to fill with oil,",
    "date": "2026-04-28",
    "id": "review-096"
  },
  {
    "product": "one",
    "rating": 5,
    "text": "I love the way it looks & how small it is. Works great in my bathroom since we have no plug in there. My only complaint is that it would be nice to add oil that smells good.",
    "date": "2026-04-24",
    "id": "review-097"
  },
  {
    "product": "one",
    "rating": 5,
    "text": "Works great love it it is small spit can be hidden, but it’s so cute also",
    "date": "2026-04-20",
    "id": "review-098"
  },
  {
    "product": "one",
    "rating": 5,
    "text": "",
    "date": "2026-04-18",
    "id": "review-099"
  },
  {
    "product": "one",
    "rating": 5,
    "text": "",
    "date": "2026-04-16",
    "id": "review-100"
  },
  {
    "product": "one",
    "rating": 5,
    "text": "",
    "date": "2026-04-15",
    "id": "review-101"
  },
  {
    "product": "one",
    "rating": 5,
    "text": "The shipping was quick I love the product we had a small issue but the company fixed it fast the scents smell good perfect diffuser",
    "date": "2026-04-15",
    "id": "review-102"
  },
  {
    "product": "one",
    "rating": 5,
    "text": "I 100% LOVE this diffuser. It is wireless so you must charge it when you get it, but even on low it puts out enough scent. It came with 3 oils, the jasmine smells as good as one I order from a well known company. I may order a few more ok 4 more. 😇",
    "date": "2026-04-12",
    "id": "review-103"
  },
  {
    "product": "one",
    "rating": 5,
    "text": "Absolutely love this above all diffusers. Can be used anywhere. Very classy looking.",
    "date": "2026-04-04",
    "id": "review-104"
  },
  {
    "product": "one",
    "rating": 5,
    "text": "",
    "date": "2026-04-03",
    "id": "review-105"
  },
  {
    "product": "one",
    "rating": 5,
    "text": "Ok a tiempo llego ok lo que pensé me lo imaginé",
    "date": "2026-03-29",
    "id": "review-106"
  },
  {
    "product": "one",
    "rating": 5,
    "text": "Works surprisingly well!",
    "date": "2026-03-11",
    "id": "review-107"
  }
];
